import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, H5, P } from "../../../../AbstractElements";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import { Link } from "react-router-dom";
import { Plus } from "react-feather";
import { AddProductCardData } from "../../../../Data/General/Dashboard/Ecommerce";

const AddProductCard = () => {
  return (
    <Col xl="5" md="6" className="xl-30 box-col-4e">
      <Card className="discount-product">
        <CardBody>
          <Row>
            {AddProductCardData.map((item, index) => (
              <Col xl="6" md="12" sm="6" className={item.class} key={index}>
                <H4 className="f-w-600">{item.title}</H4>
                <div className="d-flex align-items-center gap-2">
                  <div className={`main-box border-${item.color}`}>
                    <SvgIcon iconId={item.icon} className={`fill-${item.color}`} />
                  </div>
                  <P className="flex-grow-1">{item.description}</P>
                </div>
                <div className={`details-box bg-light-${item.color}`}>
                  <H5>{item.header}</H5>
                  <Link className={`btn btn-${item.color}`} to={`${process.env.PUBLIC_URL}${item.url}`}>
                    {item.text}<Plus className="ms-2" />
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddProductCard;
